import type { UsageUnitLimit } from '@shared/services/apiService/apiService';

export const SECONDS_PER_HOUR = 3600;

export const USAGE_UNITS = {
  callSecond: 'call-second' as UsageUnitLimit,
  llmTotalTokens: 'llm-total-tokens' as UsageUnitLimit,
  sttSecond: 'stt-second' as UsageUnitLimit,
  ttsCharacter: 'tts-character' as UsageUnitLimit,
} as const;
